import { Tabs, type TabsProps } from 'antd'
import { BookingStatusEnum } from 'app/api/booking/model/management'
import R from 'app/assets/R'
import { BaseTableManagement } from 'app/components/tables/BaseTableManagement'
import * as S from 'app/components/tables/BaseTableManagement/styles'
import { ProfileProvider } from 'app/context/ProfileContext'
import { t } from 'i18next'
import { toString } from 'lodash'
import { Assign } from './components/Assign'
import { Create } from './components/Create'
import { useHookTable } from './hook'

const BookingManagementContainer = () => {
  const {
    tableData,
    columns,
    rowSelection,
    handleTableChangeTable,
    fetchNewData,
    handleChangeFilter,
    showByManager,
    selectedRowKeys,
    selectedRows,
    setSelectedRows,
  } = useHookTable()

  const children = (
    <>
      <Assign
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        fetchNewData={fetchNewData}
      />
      <BaseTableManagement
        columns={columns}
        dataSource={tableData.data}
        rowSelection={{ ...rowSelection, selectedRowKeys }}
        pagination={tableData.pagination}
        loading={tableData.loading}
        onChange={handleTableChangeTable}
      />
    </>
  )

  const itemShowByManager = showByManager
    ? [
        {
          key: toString(BookingStatusEnum.ASSIGNED),
          label: t(R.strings.requested),
          children: children,
        },
      ]
    : []
  const items: TabsProps['items'] = [
    {
      key: toString(BookingStatusEnum.REQUEST),
      label: t(R.strings.created),
      children: children,
    },
    ...itemShowByManager,
    {
      key: toString(BookingStatusEnum.RECALL),
      label: t(R.strings.recall),
      children: children,
    },
    {
      key: toString(BookingStatusEnum.CONFIRM),
      label: t(R.strings.confirmed),
      children: children,
    },
    {
      key: toString(BookingStatusEnum.CANCEL),
      label: t(R.strings.cancel),
      children: children,
    },
  ]

  return (
    <ProfileProvider>
      <S.BaseManagementWrapper>
        <S.RootWrapper>
          <Tabs
            defaultActiveKey="1"
            items={items}
            onTabClick={value => {
              const assigned =
                showByManager && Number(value) === BookingStatusEnum.ASSIGNED
                  ? { isAssigned: true }
                  : {}
              handleChangeFilter({
                status: value as unknown as BookingStatusEnum,
                ...assigned,
              })
            }}
            tabBarExtraContent={
              showByManager && <Create fetchTable={fetchNewData} />
            }
          />
        </S.RootWrapper>
      </S.BaseManagementWrapper>
    </ProfileProvider>
  )
}
export default BookingManagementContainer
